import styled from "styled-components";
import theme from "../../../assets/theme";

export const Container = styled.div`
  margin: 0 15px;
  background-color: white;
  border-radius: 60px;
  @media ${theme?.breakpoints?.sm_up} {
    margin: 0;
  }
  & .status-list {
    border: 4px solid transparent;
    border-radius: 8px;
    margin-left: 10px;
  }
`;

export const FormContainer = styled.div`
  padding-top: 5px;
  padding-left: 28px;
  padding-right: 54px;
  padding-bottom: 6px;
  & form {
    padding-top: 10px;
  }
`;

export const Heading = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #293461;
  font-family: ${theme.fonts.primaryFontExtraBold};
`;

export const Description = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 16px;
  text-align: center;
  color: #293461;
  margin-top: 20px;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;

export const DrawerContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media ${theme?.breakpoints?.sm_up} {
    max-width: 656px;
  }
`;

export const HeadingContainer = styled.div`
  padding-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 47px;
  padding-left: 24px;
  padding-right: 24px;
`;

export const HalfWidth = styled.div`
  width: 28%;
`;

export const Form = styled.form``;
